<template>
  <div :class="{ 'pin-content-container': !hideHeader && !hideFooter }">
    <slot name="header" v-if="!hideHeader">
      <p class="m-0 text-ui-primary font-paragraph-5">
        Anda akan melakukan pembelian dengan menggunakan <span class="font-paragraph-4">Poin dari {{ catalogName }}</span>. Silakan masukkan PIN.
      </p>
    </slot>
    <div class="m-auto">
      <div class="input-pin-container">
        <single-pin-input
          v-for="(value, key) in pin"
          :key="`input-pin-${key}`"
          :active-input="key"
          :value="value"
          :max-input="maxInput"
          :is-error="isPinError"
          :show-number="showInputNumber"
          @pasteInput="pasteOtp($event,key)"
          @focus="focusInput($event)"
          @onChange="handleOnChange"
          @prevInput="deleteInput"
          @focusNext="focusInput"
        />
      </div>
      <slot name="error" :message="errorMessage" v-if="isPinError">
        <p class="error font-paragraph-5">
          {{ errorMessage }}
        </p>
      </slot>
    </div>
    <slot name="footer" v-if="!hideFooter">
      <p class="font-label-5 text-ui-primary m-0">
        Dengan mengonfirmasi proses ini, Anda menyetujui <a id="tos-button" href="/syarat-ketentuan" target="_blank" class="font-label-4 text-royal-navy-500">Syarat Ketentuan</a> dan <a id="privacy-button" href="/kebijakan-privasi" target="_blank" class="font-label-4 text-royal-navy-500">Kebijakan Privasi</a>.
      </p>
    </slot>
  </div>
</template>

<script>
import SinglePinInput from '@/components/atoms/inputs/SinglePinInput.vue'

export default {
  name: 'PinContainer',
  components: {
    SinglePinInput
  },
  props: {
    catalogName: {
      type: String,
      default: 'Nama Katalog Poin'
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    showInputNumber: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'PIN yang Anda masukkan tidak sesuai.'
    },
    maxInput: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      pin: {}
    }
  },
  computed: {
    isPinError: {
      get () {
        return this.isError
      },
      set (value) {
        this.$emit('resetstate', value)
      }
    },
    pinValues () {
      return Object.values(this.pin).filter(pin => !!pin)
    }
  },
  methods: {
    pasteOtp (event, startingPoint) {
      this.isPinError = false
      this.$nextTick(() => {
        const onlyNumberPastedData = (event.clipboardData.getData('text') || '').replace(/[^0-9]/g, '')
        const otps = onlyNumberPastedData.split('')
        for (let i = startingPoint; i < this.maxInput; i++) {
          if (otps[i - startingPoint]) {
            this.handleOnChange({
              key: i,
              value: otps[i - startingPoint]
            })
          }
        }
        this.focusInput()
      })
      event.preventDefault()
    },
    populatePIN (isAutoFocus = true) {
      this.loading = true
      let key = 0
      let newPIN = {}
      while (key < this.maxInput) {
        newPIN[key] = ''
        key++
      }
      this.pin = newPIN
      if (isAutoFocus) {
        this.focusInput()
      }
    },
    focusInput () {
      setTimeout(() => {
        const index = Math.min(this.maxInput - 1, this.pinValues.length)
        document.getElementById(`pin-input-${index}`).focus()
      }, 50)
    },
    handleOnChange ({ key, value }) {
      this.isPinError = false
      this.$set(this.pin, key, value)
    },
    deleteInput ({ key }) {
      if (this.pinValues.length === this.maxInput) {
        this.$set(this.pin, this.maxInput - 1, '')
      } else {
        this.$set(this.pin, key, '')
      }
      this.focusInput()
    }
  },
  watch: {
    pin: {
      deep: true,
      handler (value) {
        this.$emit('change', Object.values(value).join(''))
      }
    },
    isError (value) {
      if (value) {
        this.populatePIN(false)
      }
    }
  },
  created () {
    this.populatePIN()
  }
}
</script>

<style scoped>
.pin-content-container {
  display: flex;
  gap: 16px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
}

.input-pin-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}

.error {
  margin: auto;
  margin-top: 12px;
  text-align: center;
  color: var(--color-crimson-500);
}

@media screen and (min-width: 1024px) {
  .pin-content-container {
    padding: 16px 0px;
  }
}
</style>
